export const WOFLOW_UPLOAD_TYPE_FILE = 'FILE';
export const WOFLOW_UPLOAD_TYPE_URL = 'URL';
